// Module
var code = "<div> <md-tooltip md-delay=\"250\" ng-if=\"!$ctrl.noToolTip\"> {{'Time Window' | translate}} </md-tooltip> <span class=\"br-caption-2 layout-wrap\">{{{notBefore: $ctrl.start, notAfter: $ctrl.end} | timeWindow}}</span> </div> ";
// Exports
export default code;